import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button, Form, Image } from 'react-bootstrap'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { apiUrl } from "../commons/inFormTypes"
import { IPUrl } from "../commons/IPAddress"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NumericInput from 'react-numeric-input';
import BigLoaders from "../components/BigLoaders";
import recycle from "../assets/img/recycle-bin.png"



function OrderForm({ toggle, toggleHandler1, address }) {
  const [snip, setSnip] = useState(false);
  const [minSum, setMinSum] = useState();
  const [seenFile, setSeenFile] = useState([]);
  const [formIsValid, setFormIsValid] = useState("1");
  const [lstarray, setLstarray] = useState([]);
  const [lstarrayInfo, setLstarrayInfo] = useState([]);
  const [master, setMaster] = useState([{
    weight: 0, coint: 0, type: "", address: "", time: "",
    Type_Area_Id: 0, Type_Area: "", day: "", date: "", stationTitle: "",
    stationAddress: "", stationId: 0, deliveryId: 0
  }]);
  const [Stchange, setstchange] = useState(false);
  const navigate = useNavigate()
  const userToken = localStorage.getItem("user_token");

  const AddListState = (val, name, id, count, score, idWeight, titleWeight, icon, minweight) => {
    const indx = lstarray.findIndex((i) => i.id === id);
    if (val === true && indx < 0) {
      const updatedArray = [
        ...lstarray,
        {
          name: name,
          id: id,
          count: count,
          score: score,
          Sum: count * score,
          idWeight: idWeight,
          titleWeight: titleWeight,
          icon: icon,
          minweight: minweight
        }
      ];
      setLstarray(updatedArray);
    } else if (val === false) {
      const updatedArray = lstarray.filter((i) => i.id !== id);
      setLstarray(updatedArray);
    }
  };

  const AddCounter = (id, val) => {
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)
    const indx = lstarray.findIndex((i) => i.id === id);
    lstarray[indx].count = parseFloat(val);
    lstarray[indx].Sum = parseFloat(lstarray[indx].score * lstarray[indx].count);
  }


  const driverHandler = () => {
    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را اضافه کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {

      master[0].weight = 0;
      master[0].coint = 0;
      for (let i = 0; i < lstarray.length; i++) {
        master[0].weight += lstarray[i].count
        master[0].coint += lstarray[i].Sum
      }
      if (master[0].coint < minSum) {
        toast.error("مجموع مبلغ پسماندها باید از حداقل مبلغ تعیین شده بیشتر باشد", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false
      } else {
      }

      master[0].deliveryId = 3
      master[0].type = "تحویل به راننده";
      localStorage.setItem("Master", JSON.stringify(master));
      localStorage.setItem("Lstarray", JSON.stringify(lstarray));
      if (address === 1)
        navigate("../address");
      else
        navigate("address");
      toggleHandler1();
      setFormIsValid("1");
    }
  }




  const stationHandler = () => {
    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را اضافه کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      master[0].weight = 0;
      master[0].coint = 0;
      for (let i = 0; i < lstarray.length; i++) {
        master[0].weight += lstarray[i].count
        master[0].coint += lstarray[i].Sum
      }

      if (master[0].coint < minSum) {
        toast.error("مجموع مبلغ پسماندها باید از حداقل مبلغ تعیین شده بیشتر باشد", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false
      } else {
      }
      master[0].deliveryId = 5
      master[0].type = "تحویل به ایستگاه";
      localStorage.setItem("Master", JSON.stringify(master));
      localStorage.setItem("Lstarray", JSON.stringify(lstarray));
      if (address === 1)
        navigate("../stations");
      else
        navigate("stations");

      // navigate("stations");
      toggleHandler1();
      setFormIsValid("1");
    }
  }

  // const pearsonHandler = () => {
  //   if (lstarray.length <= 0) {
  //     toast.error("لطفا پسماندهای مورد نظر را اضافه کنید", {
  //       position: "top-center",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   } else {

  //     master[0].weight = 0;
  //     master[0].coint = 0;

  //     for (let i = 0; i < lstarray.length; i++) {

  //       master[0].weight += lstarray[i].count
  //       master[0].coint += lstarray[i].Sum
  //     }
  //     master[0].deliveryId = 4
  //     master[0].type = "تحویل به دوره گرد";
  //     localStorage.setItem("Master", JSON.stringify(master));
  //     localStorage.setItem("Lstarray", JSON.stringify(lstarray));
  //     navigate("finalinfo");
  //     toggleHandler1();
  //     setFormIsValid("1")
  //   }
  // }

  const submitHandler = () => {
    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را انتخاب کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      localStorage.setItem("Master", JSON.stringify(master));
      setFormIsValid("2")
    }
  }

  const newItemsHandler = () => {
    setFormIsValid("1")
    // setKey(prevState => !prevState)
  }

  const removeHandler = (id) => {
    const l = lstarray.filter((i) => i.id !== id)
    setLstarray(l)
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)

  }


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    }
    // if (toggle === false) {
    //   alert("toggle")
    // }
    else if (toggle === true) {
      const lmaster = localStorage.getItem("Master");
      if (lmaster == null) {
        setLstarray([]);
      }

      if (lstarrayInfo.length === 0) {
        const axios = require("axios");
        setSnip(true)
        axios
          .post(apiUrl + "GetList_Trash")
          .then((res) => {
            setSnip(false)
            if (res.data.result === "true") {
              setSeenFile(res.data.data);
              setMinSum(res.data.MinSum);
            } else {
            }
          });
      }
    }
  }, [Stchange, toggle]);



  return (
    <>
      <BottomSheet
        open={toggle}
        onDismiss={toggleHandler1}
        initialFocusRef={false}
        expandOnContentDrag
      >
        <div>
          <Container>
            <div className="rgc-close-icon">
              <i class="fa-regular fa-circle-xmark" onClick={toggleHandler1}></i>
              {/* <i className="fas fa-angle-down" onClick={toggleHandler1}></i> */}
            </div>
            <Row className="justify-content-center">
              <Col xs={12} lg={8} className="p-4 mb-4">

                {/* first-part */}
                <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                  <BigLoaders loads={snip} />
                  <Row className="rgc-orderform gx-5 gy-3">
                    <Col xs={12}>
                      <div className="d-flex rgc-title">
                        <div className="rgc-title-point"></div>
                        <h4>ثبت <span>سفارش</span></h4>
                      </div>
                    </Col>
                    {seenFile.map((data, index) => {
                      return (
                        <Col key={index} xs={12} md={6}>
                          <Row className="justify-content-center  rgc-station-time">
                            <Col xs={2}>
                              <Form.Group controlId="formBasicCheckbox">
                                {lstarray.findIndex((i) => i.id === data.Trashd) >= 0 ?
                                  <Form.Check
                                    className="rgc-form-check-input"
                                    checked={true}
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, 0)}
                                  /> :
                                  <Form.Check
                                    className="rgc-form-check-input"
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, 0)}
                                  />
                                }
                              </Form.Group>
                            </Col>

                            <Col xs={2} className="text-center">
                              <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={8} className="text-end">
                              <span>{data.Tittle} </span>
                            </Col>

                            <Col xs={12} className="text-start">
                              <span>مبلغ پایه:</span>
                              <span>{Intl.NumberFormat('en-US').format(data.Event_Sum)}&nbsp;ریال </span>
                            </Col>
                          </Row>

                        </Col>
                      )
                    })}

                    <Col className="rgc-order-content">
                      <Row className="justify-content-center">

                        <Col xs={5} sm={3} className="text-center">
                          <Button className="rgc-order-btn rgc-order-btn-sub" onClick={submitHandler}>
                            مرحله بعد
                          </Button>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </div>

                {/* secound-part */}
                <div className={formIsValid === "2" ? "d-block" : "d-none"}>

                  <Row className="gx-5 gy-3 rgc-order-items">

                    {lstarray.map((item) => {
                      return (
                        <Col xs={12} md={6} >
                          <Row className="justify-content-around  rgc-station-time">

                            <Col xs={2} className="rgc-order-close">
                              <i className="fa-solid fa-circle-xmark" onClick={() => removeHandler(item.id)}></i>
                            </Col>

                            <Col xs={4} className="text-start">
                              <Image src={IPUrl + item.icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={6} className="text-end rgc-order-title">
                              <span> {item.name}</span>
                            </Col>
                            <hr className="w-75" />
                            <Col xs={12}>
                              <Form.Group className="row g-0 align-items-center justify-content-center" controlId="formBasicEmail">
                                {/* <Col xs={3} className="rgc-order-label">
                                  <Form.Label className="m-0">وزن زباله</Form.Label>
                                </Col> */}
                                <Col xs={7}>
                                  <NumericInput
                                    step={0.5}
                                    precision={1}
                                    min={0.5}
                                    value={item.count}
                                    mobile
                                    onChange={(value) => { AddCounter(item.id, value) }}
                                  />
                                </Col>

                                <Col xs={3} className="rgc-order-label text-center">
                                  <Form.Label className="m-0">{item.titleWeight}</Form.Label>
                                </Col>
                              </Form.Group>
                            </Col>

                            <Col xs={9} className="rgc-driver-txt text-center my-2">
                              {/* <div className="d-flex  justify-content-between"> */}
                              <div className="rgc-order-span rgc-order-span-item">
                                <span>مبلغ پایه:</span>
                                <span>{Intl.NumberFormat('en-US').format(item.score)}&nbsp;ریال </span>
                              </div>

                              <div className="rgc-order-span rgc-order-span-item">
                                <span>مجموع مبلغ:</span>
                                <span>{Intl.NumberFormat('en-US').format(item.Sum)}&nbsp;ریال </span>
                              </div>

                              {/* </div> */}
                            </Col>
                          </Row>

                        </Col>
                      )
                    }
                    )}
                  </Row>

                  <Row>
                    <Col xs={12} className="rgc-order-icon">
                      <i className="fa fa-plus-circle" aria-hidden="true" onClick={newItemsHandler}></i>
                    </Col>

                    <Row>
                      <Col className="rgc-order-content">
                        <Row className="justify-content-center">
                          <Col xs={12} className="text-center rgc-order-score">
                            <span>حداقل مبلغ  برای  سفارش باید {Intl.NumberFormat('en-US').format(minSum)} ریال باشد</span>
                            <span>مجموع مبالغ :{Intl.NumberFormat('en-US').format(lstarray.reduce((acc, item) => acc + item.count * item.score, 0))} &nbsp;&nbsp;ریال</span>
                            <span>مجموع کل وزن :{(lstarray.reduce((acc, item) => acc + item.count * 1, 0)).toFixed(1)}</span>
                          </Col>

                          <Col xs={4} md={3} className="text-center">
                            <Button className="rgc-order-btns  rgc-order-btn-sub" onClick={driverHandler} >
                              تحویل به راننده
                            </Button>
                          </Col>

                          <Col xs={4} md={3} className="text-center" >
                            <Button className="rgc-order-btns  rgc-order-btn-sub" onClick={stationHandler} >
                              تحویل به ایستگاه
                            </Button>
                          </Col>

                          {/* <Col xs={4} md={3} className="text-center">
                            <Button className="rgc-order-btns rgc-order-btn-sub" onClick={pearsonHandler} >
                              تحویل به دوره گرد
                            </Button>
                          </Col> */}
                        </Row>
                      </Col>
                    </Row>
                  </Row>
                </div>

              </Col>
            </Row>

          </Container>

        </div>
      </BottomSheet>
    </>

  );
}

export default OrderForm;
